import { getLastYearsWithColors } from "../../../../pages/lastYearsMapFilter"
import { store } from "../../../../stateManagement/store"
import { roadBedFiltersOptions } from "../mapOverlayWidget/roadBedLayerSegmentsOverlay"
import { roadCategoryFiltersOptions } from "../mapOverlayWidget/roadCategorySegmentsOverlay"

const ROAD_ACCIDENT_COLORS: any = {
    1: '#7030A0',
    2: '#000000',
    3: '#00B050',
    4: '#FFB841',
    5: '#FF0000',
    6: '#99FF66',
    7: '#7F1734',
    8: '#7FFFD4',
    9: '#CC6600',
    90: '#000080',
    91: '#FFC000',
    92: '#FFB841',
    95: '#FF00FF',
    96: '#FF00FF',
    97: '#FF00FF',
    others: '#CC6600'
}

const ROAD_WORKS_COLORS: any = {
    1: '#1F77B4',
    2: '#FF7F0E',
    3: '#2CA02C',
    4: '#D62728',
    5: '#9467BD',
    6: '#8C564B',
    7: '#E377C2',
    8: '#7F7F7F',
    9: '#BCBD22',
    10: '#17BECF',
    11: '#843C39',
    12: '#393B79',
    13: '#637939',
    14: '#8C6D31',
}

const mapsWithEventYearTooltipColor = ['RoadDiagnosticsSegments', 'RoadWorkSegmentsPODD', 'RoadDiagnosticsSegmentsPassport']

export function getMapTooltipBorderColor(type: string) {
    const mapTooltip = store.getState().mapTooltip
    const { eventYear, roadBedType, roadBedTypeId, roadCategory, roadCategoryId, eventTypeId, roadAccidentDeathRoll, roadAccidentTypeId } = mapTooltip ?? {}
    const normativityFlag = store.getState().diagnosticsPathNormativities.pathNormativitiesMapNormativityFlag
    const zoom = store.getState().map.mapPosition?.zoom
    if (mapsWithEventYearTooltipColor.includes(type) && eventYear) {
        return getLastYearsWithColors(5).find(item => item.year == eventYear)?.color || '#ebebeb';
    } else if (roadBedType && roadBedTypeId && type === 'RoadBedLayerSegments') {
        const found: any = Object.values(roadBedFiltersOptions).find(opt => opt.roadbedTypeId === roadBedTypeId);
        return found?.color || '#ebebeb';
    } else if (roadCategory && roadCategoryId && type === 'RoadCategorySegments') {
        const found: any = Object.values(roadCategoryFiltersOptions).find(opt => opt.categoryId === roadCategoryId);
        return found?.color || roadCategoryFiltersOptions['others'].color;
    } else if (type === 'PathNormativitiesGroupMeasure') {
        return normativityFlag ? '#44CC00' : '#E15112';
    } else if (type === 'RoadAccidents') {
        if (zoom > 15) return roadAccidentDeathRoll > 0 ? '#EE5533' : '#2266AA';
        return ROAD_ACCIDENT_COLORS[roadAccidentTypeId] || ROAD_ACCIDENT_COLORS.others;
    } else if (['RoadWorks', 'RoadWorksWithNormativities'].includes(type)) {
        return ROAD_WORKS_COLORS[eventTypeId] || ROAD_WORKS_COLORS.others;
    }
    return '#ebebeb';
}

export function getMapTooltipBorderWidth(type: string){
    return type === 'HighwayNetworkSegments' ? '5px' : '3px';
}